/** Endereço da API sem a barra final. Vazio = mesma origem (em desenvolvimento o Vite faz proxy). */
export function apiBaseUrl(): string {
  return (import.meta.env.VITE_API_URL ?? '').replace(/\/+$/, '');
}

/**
 * Endereço público do site, sem a barra final: usado onde o endereço é mostrado ou compartilhado (a senha do grupo, a tela da TV).
 * Vazio = a origem desta página; no app Android a origem é interna ao aparelho, então defina `VITE_WEB_URL` no build.
 */
export function webOrigin(): string {
  const configured = (import.meta.env.VITE_WEB_URL ?? '').replace(/\/+$/, '');
  return configured || window.location.origin;
}

/** Versão do app (package.json, injetada no build); o servidor compara com `minClientVersion`. */
export const APP_VERSION: string = __APP_VERSION__;
